import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import DelaiPaiement from '../FichePanel/Complements/DelaiPaiement/DelaiPaiement';

const DelaiPaiementComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (changes: Record<string, unknown>) =>
		onChange?.(changes, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form data-testid="delaiPaiementPanel">
				<DelaiPaiement
					dateDepartDelaiGlobalPaiement={data?.dateDepartDelaiGlobalPaiement}
					dateFinDelaiGlobalPaiement={data?.dateFinDelaiGlobalPaiement}
					dureeDelaiGlobalPaiement={data?.dureeDelaiGlobalPaiement}
					onChange={handleChange}
				/>
			</Form>
		</Panel>
	);
};

export default DelaiPaiementComponent;
